import React from 'react';
export default (
  <svg width="15px" height="14px" viewBox="0 0 15 14">
    <defs>
      <path
        d="M17.5548104,16.8342632 L27.2724607,16.8342632 L23.0269698,20.905497 C22.6876785,21.230862 22.6876785,21.7647942 23.0269698,22.0901592 C23.3662611,22.4155242 23.914347,22.4155242 24.2536383,22.0901592 L29.986791,16.5923251 C30.3260822,16.2669601 30.3260822,15.7413705 29.986791,15.4160055 L24.2623381,9.90982874 C24.0997988,9.75360961 23.8791282,9.66581701 23.6490038,9.66581701 C23.4188794,9.66581701 23.1982088,9.75360961 23.0356696,9.90982874 C22.6963783,10.2351937 22.6963783,10.7607833 23.0356696,11.0861483 L27.2724607,15.1657248 L17.5548104,15.1657248 C17.0763227,15.1657248 16.6848328,15.5411459 16.6848328,15.999994 C16.6848328,16.4588421 17.0763227,16.8342632 17.5548104,16.8342632 Z"
        id="arrowNext_svg__a"
      />
    </defs>
    <use
      transform="matrix(-1 0 0 1 30.926 -9)"
      xlinkHref="#arrowNext_svg__a"
      fillRule="evenodd"
    />
  </svg>
);
